import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Map name is required')
    .max(50, 'Maximum length is 50 characters'),
  description: Yup.string().max(50, 'Maximum length is 50 characters'),
});

export default validationSchema;
